import React, { useState } from 'react';
import { maskCEP } from '../../utils/masks';

export default function CepInput({ value, onChange, onAddressFound, className = '' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = async (e) => {
    const masked = maskCEP(e.target.value);
    onChange(masked);
    setError('');
    if (masked.replace(/\D/g, '').length === 8) {
      setLoading(true);
      try {
        const cep = masked.replace(/\D/g, '');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal: controller.signal });
        clearTimeout(timeout);
        const data = await res.json();
        if (data.erro) {
          setError('CEP não encontrado');
          onAddressFound && onAddressFound(null);
        } else {
          onAddressFound && onAddressFound({
            logradouro: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
            uf: data.uf,
          });
        }
      } catch {
        setError('Erro ao buscar CEP. Preencha manualmente.');
        onAddressFound && onAddressFound(null);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder="00000-000"
          maxLength={9}
          className={`${className} pr-10`}
          data-testid="cep-input"
        />
        {loading && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <div className="w-4 h-4 border-2 border-brand-primary border-t-transparent rounded-full animate-spin" />
          </div>
        )}
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}
